import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host, api_auth} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';
// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import WarningIcon from '@material-ui/icons/Warning';
import Tooltip from '@material-ui/core/Tooltip';
import Elements from '../../BaseElementsPlus/ElementsPlus'
import moment from 'moment'
import 'moment/locale/es'  
import { AtCircularProgress } from '../../../../../components/AtCircularProgress';
import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';
moment.locale('es')

class ResponseTimeRankTable extends Component {

    constructor(props) {
        //console.log(props)
        var listObj= JSON.parse(sessionStorage.getItem("listaObjetivosOnline"))
        //console.log('lista', listObj)
        //console.log('obj', props.params.props.obj)
        const selectedValue = props.params.props.obj
        var DataNodos = listObj.filter((item) => item.objetivo_id == selectedValue).map(({Nodos, servicio_id}) => ({Nodos, servicio_id}))
        var Nodos=(DataNodos[0]["Nodos"].filter((node) => node.nodo !== "Global"))
        //console.log('nodes', Nodos, DataNodos[0]["servicio_id"])
        var flagEle= false
        if([258,270,271,272].includes(DataNodos[0]["servicio_id"])===true){
            flagEle=true
        }
        super(props);
        this.state = {
            currentObjectiveId: this.props.params.props.obj,
            prevObjectiveId: this.props.params.props.obj,
            nodes:DataNodos[0]["Nodos"],
            eleButton:flagEle,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase,
            chartOptions: this._chartOptionsBase,
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            listObjectives: this.props.params.props.listObjectives,
            modalOpenEle:false,
        }  
    }
    
    _chartOptionsBase = {
        chart: {
            type: 'spline',
            zoomType: 'x',
            ignoreHiddenSeries: false,
            marginRight: 30,
            resetZoomButton: {
                theme: {
                    fill: 'white',
                    stroke: 'silver',
                    r: 0,
                    states: {
                        hover: {
                            fill: '#41739D',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            }
        },
        title: {
            text: null
        },
        /*subtitle: {
            text: 'Hola'
        },*/
        xAxis: {
            lineColor: '#c0c0c0',
            type: 'datetime',
            minorGridLineColor: '#E0E0E0',
            minorTickLength: 0,
            gridLineWidth: 0.3,
            showFirstLabel: true,
            dateTimeLabelFormats: {
                second: '%l:%M:%S%P',
                minute: '%l:%M%P',
                hour: '%H:%M',
                day: '<br/><b>%e/%b</b>',
                week: '%e. %b',
                month: '%b %y',
                year: '%Y'
            },
            /*title: {
                useHTML:true,
                style: { color: '#5A5A5A', fontSize: '12px', fontWeight: 'bold' },
                text: '<br/>Período'
            },	*/
            labels: {
                useHTML: true,
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Tiempo de Respuesta (s)'
            },
            plotLines: []
        },
        setOptions: {
            time: {
                useUTC: false
            },
            lang: {
                months: [
                    'Enero', 'Febrero', 'Marzo', 'Abril',
                    'Mayo', 'Junio', 'Julio', 'Agosto',
                    'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ],
                weekdays: [
                    'Domingo', 'Lunes', 'Martes', 'Miercoles',
                    'Jueves', 'Viernes', 'Sabado'
                ]
            }
        },
        plotOptions: {
            series: {
                turboThreshold: 20000,
                gapSize: 2,
                marker: {
                    symbol: 'circle',
                    width: 8,
                    height: 8,
                    enabled: false
                },
            },

        },

        legend: {
            enabled: true
        },
        navigator: {
            enabled: null
        },
        tooltip: {
            enabled: true,
            pointFormat: 'Tiempo de respuesta: <b>{point.y:.2f} (s)</b>'
        },
        credits: {
            enabled: false
        },
        series: []


    }

    setHoverData = (e) => {
        const { x, y, series } = e.target
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['y'] = y
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        /*if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else */if (props.params.state.period !== state.time) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                //prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.state.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                //statePeriod: props.params.statePeriod,
                //isStatePeriod: props.params.isStatePeriod
            }
        } /*else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptions: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }*/
        return null;
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        /*if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }*/
        if ((prevProps.params.state.period !== this.state.time)) {
            this.getDataFromAPI();
        }

    }
    

    getDataFromAPI = (objectiveId) => {
      
        const { obj } = this.props.params.props
        const { listObjectives } = this.props.params.props
        const { period, statePeriod } = this.props.params.state
  
        let listObjective = []
        Object.keys(listObjectives).map(key => {            
            Object.keys(listObjectives[key]).map(key2 => {
                if (listObjectives[key][key2].objetivo_id == obj){
                    listObjective.push(listObjectives[key][key2]);
                    //break;
                }
            })
        })
        let sla_rendimiento_ok = parseInt(listObjective[0].sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(listObjective[0].sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(listObjective[0].sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(listObjective[0].sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoGlobalObjetivoCustom/?objetivoId=${obj}&token=${token}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&horarioId=0&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            /*if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }*/
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoParcialObjetivoRank/?objetivoId=${obj}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&t=${period}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            /*if (this.state.lastEvent !== []) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }*/
                        } catch (error) {
                            console.log(error)
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {
            const {nodes}=this.state
            //console.log('node in process', nodes)
            let rowLen = externalData.Objetivo.Paso.length
            let arrayRows = []            
            let estado = externalData.Objetivo.Paso
            if (estado.length > 0) {
                Object.keys(estado).map((key)=> {
                    //console.log(estado[key])
                    var dataNodeProps=(nodes.filter((node) => node.id_nodo === estado[key]["nodo_id"]))
                    let rows = {}
                
                    let fecha = new Date(estado[key]['fecha_min'])
                    rows['fecha'] = fecha.toLocaleDateString("en-GB",{ year: "numeric",month: "2-digit",day: "2-digit",}).replace('/', '-').replace('/', '-')
                    +" "+
                    fecha.toLocaleTimeString("en-GB",{ hour: "2-digit", minute: "2-digit", second:"2-digit" })
                    //console.log(estado[key])
                    rows['paso'] = estado[key]['paso']['nombre']
                    rows['paso_orden'] = estado[key]['paso_orden']
                    rows['nodo'] = estado[key]['nodo']['nombre']
                    rows['nodo_id'] = estado[key]['nodo_id']
                    rows['respuesta'] = estado[key]['respuesta']
                    rows["monitor_id"] = dataNodeProps[0]["monitor"]
                    if(estado[key]['respuesta'] >= sla_rendimiento_error){
                        rows['customColumnStyle'] = { color: "red" }
                    } else {
                        rows['customColumnStyle'] = { color: "green" }
                    }
                    
                    arrayRows.push(rows)        
                })    
    
                this.setState({
                    rows : arrayRows,                    
                    isLoading: false,                    
                    dataError: false,
                });
            } else {
                this.setState({
                    
                    isLoading: false,
                    rows: null,                   
                    dataError: false,
                });
            }
    }

    setOpenElements=(e)=>{
        //console.log(e)
        var step=[{"nombre_paso":e.paso, "id_paso":e.paso_orden}]
        var fecha={"fecha": moment(e.fecha, 'DD-MM-YYYY %HH:%mm:%ss').format("YYYY-MM-DDTHH:mm:ss")}
        var monitor={"monitor":e.monitor_id}
        var obj=this.state.currentObjectiveId
        //[{nombre_paso: "Coach", id_paso: 1}],{fecha: "2020-05-07T15:34:21"}, {monitor: 1554}, 57844
        //console.log(step, fecha, monitor )
        this.setState({
            dataElements:{step, fecha, monitor,obj },
            modalOpenEle: true,
            modalCloseEle : false,
        })
    }

    setCloseModalEle=()=>{
        this.setState({
            modalOpenEle : false,
            modalCloseEle : true
        })
    }

    getElement=()=>{
        const {dataElements, nodes} =this.state
        if(typeof(dataElements)!=="undefined"){
            var dataNode= nodes.filter(ele=>ele.monitor===dataElements.monitor.monitor)[0]
            return <Elements objective={dataElements.obj} steps={dataElements.step} date={dataElements.fecha} overview={true} params={this.props.params}
                node={dataElements.monitor} onClose={this.setCloseModal} dataNode={dataNode}/>
        }else{
            return (null)
        }
        
    }
    render() {
        const { dataError, isLoading, rows, modalOpenEle, eleButton} = this.state;
        const style = isLoading ? { display: 'none' } : {overflowX: 'auto'};
        const styleHidden = isLoading ? {} : { display: 'none' };
        //console.log(eleButton)
        const t = (this.props && this.props.t) ? this.props.t : (s => s) 
        if (!dataError) {
            return (
                <div >
                <div style={styleHidden}>
                <AtCircularProgress />
                </div>
                <div style={style}>
                    { rows == null  ? 
    
                        <Table style={{overflowX: 'auto'}} stickyHeader aria-label="spanning table" >
                        <TableHead style={{backgroundColor:"#ffffff"}}>
                            <TableRow>
                                <TableCell style={{color:"#6b6b6b"}}>{t('modal.objective.slow-transactions.table.date')}</TableCell>
                                <TableCell style={{color:"#6b6b6b"}}>{t('modal.objective.slow-transactions.table.details')}</TableCell>
                                <TableCell style={{color:"#6b6b6b"}}>{t('modal.objective.slow-transactions.table.step')}</TableCell>
                                <TableCell style={{color:"#6b6b6b"}}>{t('modal.objective.slow-transactions.table.isp')}</TableCell>
                                <TableCell style={{color:"#6b6b6b"}}>{t('modal.objective.slow-transactions.table.response-time')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
    
                        </TableBody>
                        </Table>
                        
                       
                    :   <Table  aria-label="spanning table" >
                        <TableHead style={{backgroundColor:"#ffffff"}}>
                            <TableRow>
                                <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{t('modal.objective.slow-transactions.table.date')}</TableCell>
                                <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{t('modal.objective.slow-transactions.table.details')}</TableCell>
                                <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{t('modal.objective.slow-transactions.table.step')}</TableCell>
                                <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{t('modal.objective.slow-transactions.table.isp')}</TableCell>
                                <TableCell style={{color:"#6b6b6b", textAlign: "center"}}>{t('modal.objective.slow-transactions.table.response-time')}</TableCell>
                            </TableRow>
                        </TableHead>  
                        <TableBody style={{ border:'0px'}}>
                            {  rows.map( (row, index) => (
                                /* Efecto ODD / EVEN */
                                <TableRow style= { index % 2 === 0 ? { backgroundColor : "#ebebeb", border:'0px' } : 
                                                  { backgroundColor : "#ffffff", border:'0px' }} > 
                              

                                    <TableCell style={{ border:'0px', textAlign: "center"}}>{`${row.fecha}`}</TableCell>
                                    <TableCell style={{ border:'0px'}}> 
                                        {eleButton==true ?
                                        <Tooltip title="Ver detalle de elementos descargados" placement="top-start">
                                            <Button onClick={(e)=>{this.setOpenElements(row)}}>
                                            <FindInPageIcon />
                                            </Button>
                                        </Tooltip>

                                        : null 
                                        }
                                    </TableCell>
                                    <TableCell style={{ border:'0px', textAlign: "center"}}>{row.paso}</TableCell>
                                    <TableCell style={{ border:'0px', textAlign: "center"}}>{row.nodo}</TableCell>
                                    <TableCell style={{border:'0px'}}>  
                                        <div style={{fontWeight: 'bold', fontSize: 15, color: '#FF9933', textAlign: "center"}}>{row.respuesta}</div>
                                     </TableCell>
                                </TableRow>
                            ))}                        
                        </TableBody>
                        <Modal
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            open={modalOpenEle}
                            onClose={this.setCloseModalEle}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                            disableAutoFocus={true}
                            disableEnforceFocus={true}
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 100,
                            }}               
                        >
                            <Fade in={modalOpenEle}>
                                {this.getElement()}
                            </Fade>
                        </Modal>
                    </Table>}
                </div>
            </div>
                ) 
        }
        else if (dataError) {
            return (<p>{t('modal.objective.render.no-data')}</p>)
        }
        else return (<p> {t('modal.objective.render.error')}</p >)

    }
}



export default compose(withRouter, withTranslation())(ResponseTimeRankTable);